import React, { useState } from "react";
import { Input } from "antd";
import { SearchIcon } from "../../common/CustomIcon";

const Search_v2 = ({
  className,
  placeholder = "Search",
  onSearch,
  ...rest
}) => {
  const [searchText, setSearchText] = useState("");
  const handleSearch = () => {
    if (onSearch) {
      onSearch(searchText);
    }
  };
  return (
    <div className="search-comp custom-form-item">
      <Input
        className={className}
        placeholder={placeholder}
        value={searchText}
        onChange={(e) => setSearchText(e.target.value)}
        onPressEnter={handleSearch}
        prefix={<SearchIcon onClick={handleSearch} />}
        {...rest}
      />
    </div>
  );
};

export default Search_v2;